import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=37ac438e&"
import script from "./CustomerSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ac438e')) {
      api.createRecord('37ac438e', component.options)
    } else {
      api.reload('37ac438e', component.options)
    }
    module.hot.accept("./CustomerSelect.vue?vue&type=template&id=37ac438e&", function () {
      api.rerender('37ac438e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/zoho/CustomerSelect.vue"
export default component.exports